import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class OtpMetaModel extends FormMetaModel {
    constructor() {
        super('otp', ROUTE_PATH.otp , ROUTE_PATH.dashboard, 1);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const otp = new SmMetaInputModel(
            'otp',
            'otp',
            'input',
            false,
            'form-control col-12 ',
            1,
            1,
            'Enter OTP',
            'text',
            '',
            false,
            true,
            true,
            false,
            6,
            6
        );

       const isPrivacyPopupOpen = false
        

        const otp_button = new SmBtnMetaModel('SIGN IN', 'primary', true, false, true, true,true);
        const terms_button = new SmBtnMetaModel('Start', 'primary', true, false, true, true,true);

        const isEditable = [
            otp_button,
            terms_button
        ]

        return {
            formInfo,
            otp,
            otp_button,
            terms_button,
            isPrivacyPopupOpen,
            isEditable
        };
    }

    
}